import React, { JSX, useMemo } from "react";
import { useUserContext } from "../context/UserContext";
import { useLabelsContext } from "../context/LabelsContext";
import "../styles/Greeting.scss";
import "../styles/NavButtons.scss";
import { useClubContext } from "../context/ClubContext";
import { CRM_TYPES } from "../models/crm-types";
import { useAuthContext } from "../context/AuthContext";
import { MemberIcon } from "./MemberIcon";
import { AUTH_STEPS } from "../models/auth-steps";
type GreetingProps = {
	closeModal?: () => void;
};

const Greeting: React.FC<GreetingProps> = ({ closeModal }) => {
	const { user, onLogout, isLoggingOut } = useUserContext();
	const { labels } = useLabelsContext();
	const { personalAreaUrl } = useClubContext();
	const { otpMethod, setAuthStep } = useAuthContext();
	const { club } = useClubContext();

	const header = useMemo((): JSX.Element => {
		const clubLogoUrl: string | null = club?.clubLogoUrl || null;
		const clubName: string = club?.clubName || "";

		return (
			<div className='popup-header'>
				<span>{labels?.["ClubMailSender"]}</span>
				{clubLogoUrl ? (
					<img src={clubLogoUrl} className='popup-club-logo' />
				) : (
					<span className='popup-club-name'>{clubName}</span>
				)}
			</div>
		);
	}, [club, labels]);

	return (
		<div className='greeting-container'>
			{header}
			<div className='greeting-text'>
				<MemberIcon />
				<span className='title'>
					{labels?.["Greetings"]?.replace("{0}", user?.Name ?? "")}
				</span>
				<span className='body'>{labels?.["CM_GreetingText"]}</span>
			</div>
			<div className='nav-buttons'>
				{club?.cRMType !== CRM_TYPES.OCTOPUS && (
					<a
						href={personalAreaUrl}
						className={`nav-button nav-button-primary ${isLoggingOut ? "disabled" : ""}`}
					>
						{labels?.["ToPrivateArea"]}
					</a>
				)}
				<button
					onClick={() => {
						closeModal && closeModal();
						onLogout(otpMethod).then((success: boolean) => {
							success && setAuthStep(AUTH_STEPS.LOGIN);
						});
					}}
					disabled={isLoggingOut}
					className='nav-button nav-button-secondary'
				>
					{isLoggingOut && <span className='loader primary'></span>}
					{labels?.["LogOut"]}
				</button>
			</div>
		</div>
	);
};
export default Greeting;
